import { ca } from '@cian/analytics';
import { INewbuildingInfo } from '../../../../api/newbuildings';
import { getDeveloperContactsLabel } from '../developers_contacts/tracking';

export function trackNewbuildingFavoriteButtonClick(newbuildingInfo: INewbuildingInfo, isFavorite: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: isFavorite ? 'add_from_about_JK' : 'remove_from_about_JK',
    label: getDeveloperContactsLabel(newbuildingInfo),
    products: [
      {
        id: Number(newbuildingInfo.id),
        name: newbuildingInfo.name,
        objectType: 'JK',
        position: 1,
      },
    ],
  });
}
